import { styled, Theme } from '@material-ui/core';

export const TOCImage = styled('img')<Theme, { loaded: boolean }>(({ loaded }) => ({
  width: '100%',
  display: loaded ? 'block' : 'none',
  borderRadius: 16,
  aspectRatio: 2 / 3,
  objectFit: 'cover',
}));
